export default __webpack_public_path__ + "static/media/iphone1.15553f1d.png";